// extracted by mini-css-extract-plugin
module.exports = {"no_found":"Index_no_found__-q1aW"};